"use client"

import type { ReactNode } from "react"

import { useTranslations } from "next-intl"

import { Breadcrumbs, Heading, Stack, Text } from "@/components/ui"
import type { Crumb } from "@/components/ui"

interface ListingHeaderProps {
  breadcrumbs?: Crumb[]
  title: ReactNode
  subline?: ReactNode
  count?: number
  countKeyword?: string
  actions?: ReactNode
}

export const ListingHeader = ({ breadcrumbs, title, subline, count, countKeyword, actions }: ListingHeaderProps) => {
  const t = useTranslations("search")
  const resultCount = count?.toLocaleString("es-MX")
  const countLine =
    resultCount === undefined ? undefined : countKeyword ? t("header.resultsForCount", { resultCount, keyword: countKeyword }) : t("filterBar.resultsCount", { resultCount })

  return (
    <Stack gap="300">
      {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumbs items={breadcrumbs} />}
      <div className="flex items-center justify-between gap-300">
        <Stack gap="100" className="min-w-0">
          <Heading as="h1" variant="sectionHead" family="text" tone="strong" balance>
            {title}
          </Heading>
          {(subline ?? countLine) && (
            <Text as="span" variant="body" tone="muted" numeric>
              {subline ?? countLine}
            </Text>
          )}
        </Stack>
        {actions}
      </div>
    </Stack>
  )
}
